import React, { useEffect } from "react";
import {
  closeRecommendedEventModal,
  fetchRecommendedEventDetail,
  selectRecommendedEventDetail,
} from "store/event/recommendedEventDetail.slice";
import { useAppDispatch, useAppSelector } from "store/hooks";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ShareIcon from "@mui/icons-material/Share";
import ImageWithFallback from "components/common/ImageWithFallback";
import Loader from "components/common/Loader";
import {
  CloseButton,
  DetailInfoLine,
  EventDetailBody,
  ModalBackdrop,
  ModalContent,
  ModalError,
  ModalImage,
  ModalTitle,
} from "./NewEvents.styles";

const RecommendedEventModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isOpen, selectedEventId, data, isLoading, error } = useAppSelector(
    selectRecommendedEventDetail
  );

  const image_url = data?.visuals[0]?.image_url;

  useEffect(() => {
    if (isOpen && selectedEventId && !data) {
      dispatch(fetchRecommendedEventDetail(selectedEventId));
    }
  }, [isOpen, selectedEventId, data, dispatch]);

  if (!isOpen) return null;

  const handleClose = () => {
    dispatch(closeRecommendedEventModal());
  };

  return (
    <ModalBackdrop>
      <ModalContent>
        <CloseButton onClick={handleClose}>×</CloseButton>
        {isLoading && <Loader message="Loading event detail..." />}
        {error && <ModalError>{error}</ModalError>}
        {!isLoading && !error && data && (
          <>
            <ModalTitle>{data.activity.activity_title}</ModalTitle>
            <ModalImage
              as={ImageWithFallback}
              src={image_url}
              alt="Event"
            />
            <EventDetailBody>
              {data.activity.activity_description}
            </EventDetailBody>

            <DetailInfoLine>
              <AccessTimeIcon style={{ fontSize: "20px", color: "#757575" }} />
              {`${new Date(data.activity.start_date_time).toLocaleDateString()} 
          ${new Date(data.activity.start_date_time).toLocaleTimeString()} - 
          ${new Date(data.activity.end_date_time).toLocaleTimeString()}`}
            </DetailInfoLine>

            <DetailInfoLine>
              <LocationOnIcon style={{ fontSize: "20px", color: "#757575" }} />
              {data.places.length > 0
                ? `${data.places[0].place_city}, ${data.places[0].place_state
                } ${data.places[0].place_postcode || ""}`
                : "Unknown"}
            </DetailInfoLine>

            <DetailInfoLine>
              <BookmarkIcon style={{ fontSize: "20px", color: "#757575" }} />
              Save to events calendar
            </DetailInfoLine>
            <DetailInfoLine>
              <ShareIcon style={{ fontSize: "20px", color: "#757575" }} />
              Share
            </DetailInfoLine>
          </>
        )}
      </ModalContent>
    </ModalBackdrop>
  );
};

export default RecommendedEventModal;
